import getApiClient from 'src/utils/getApiClient'
import type {
  ApiAnalysesDistrictsParams,
  ApiAnalysesDistrictsResponse,
} from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesDistricts.types'

const DISTRICTS_URL = '/api/town/metros-and-districts/'

const apiClient = getApiClient()

const apiAnalysesDistricts = {
  get(params: ApiAnalysesDistrictsParams) {
    return apiClient.get<ApiAnalysesDistrictsResponse>(DISTRICTS_URL, { params })
  },
}

export default apiAnalysesDistricts
